import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import RentItems from "./components/RentItems";
import Team from "./components/Team";
import { ContactPage } from "./components/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rentitems" element={<RentItems />} /> 
        <Route path="/team" element={<Team />} /> 
        <Route path="/contact" element={<ContactPage />} /> 


      </Routes>
    </BrowserRouter>
  );
}

export default App;
